import React, { useCallback } from 'react';
import { GameMode } from '@shared/types';
import { useGameState } from '@/hooks/useGameState';
import MainMenu from '@/screens/MainMenu';
import Lobby from '@/screens/Lobby';
import GameScreen from '@/screens/GameScreen';
import ResultScreen from '@/screens/ResultScreen';
import socket from '@/socket';

export default function App() {
  const {
    screen,
    setScreen,
    roomInfo,
    gameState,
    roundResult,
    finalScores,
    sessionKey,
    isConnected,
    error,
    clearError,
  } = useGameState();

  const handleCreateRoom = useCallback((nickname: string, mode: GameMode) => {
    socket.emit('lobby:createRoom', { nickname, mode, sessionKey }, (res) => {
      if (res.success && res.room) {
        setScreen('lobby');
      } else {
        console.error('Create room failed:', res.error);
      }
    });
  }, [sessionKey, setScreen]);

  const handleJoinRoom = useCallback((nickname: string, code: string, mode: GameMode) => {
    socket.emit('lobby:joinRoom', { roomCode: code, nickname, sessionKey }, (res) => {
      if (res.success && res.room) {
        setScreen('lobby');
      } else {
        console.error('Join room failed:', res.error);
      }
    });
  }, [sessionKey, setScreen]);

  const handleLeave = useCallback(() => {
    setScreen('menu');
  }, [setScreen]);

  const handleDismissResult = useCallback(() => {
    // Round result dismissed — state will update automatically from server
  }, []);

  const handlePlayAgain = useCallback(() => {
    setScreen('menu');
  }, [setScreen]);

  // Route to screens
  if (screen === 'game' && gameState) {
    return (
      <GameScreen
        state={gameState}
        roundResult={roundResult}
        onDismissResult={handleDismissResult}
        sessionKey={sessionKey}
      />
    );
  }

  if (screen === 'result' && finalScores) {
    return (
      <ResultScreen
        scores={finalScores}
        mode={gameState?.mode ?? '101'}
        onPlayAgain={handlePlayAgain}
        onMainMenu={handleLeave}
      />
    );
  }

  if (screen === 'lobby' && roomInfo) {
    return (
      <Lobby
        room={roomInfo}
        mySessionKey={sessionKey}
        onLeave={handleLeave}
      />
    );
  }

  return (
    <MainMenu
      onCreateRoom={handleCreateRoom}
      onJoinRoom={handleJoinRoom}
      isConnected={isConnected}
    />
  );
}
